// ══════════════════════════════════════════════════════════
// privacy-policy.component.ts
// ══════════════════════════════════════════════════════════
import { Component } from "@angular/core"
import { ActivatedRoute, RouterLink } from "@angular/router"

@Component({
    selector: "hs-privacy-policy",
    standalone: true,
    imports: [RouterLink],
    templateUrl: "./privacy-policy.component.html",
    styleUrl: "./privacy-policy.component.scss",
})
export class PrivacyPolicyComponent {
    readonly currentYear = new Date().getFullYear()

    constructor(public route: ActivatedRoute) {
        this.route.fragment.subscribe(this.navToFragment)
    }

    navToFragment(fragment: string) {
        if (fragment) {
            // Find the element by the fragment string (e.g., #pricing -> "pricing")
            const element = document.getElementById(fragment)
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth" })
                }, 0)
            }
        }
    }
}
